'use client';

import React from 'react';
import { css, cx } from 'styled-system/css';

import ShaojiangImage from '@shaojiang/components/ShaojiangImage';

const testimonialRecords = [
  {
    id: 1,
    avatar: '/showcase/enterprise/avatar-1.png',
    name: 'Alex Suprun',
    title: 'Love the simplicity of Dashboard!',
    role: 'Co founder of Sooprun',
    say: 'Very nice dashboard. my team also feel comfortable when using it and our work becomes easier and more organized.',
  },
  {
    id: 2,
    avatar: '/showcase/enterprise/avatar-2.png',
    name: 'Robert Downson',
    title: 'Nice Dashboard. Love your work !',
    role: 'Product Designer',
    say: 'Very nice dashboard. my team also feel comfortable when using it and our work becomes easier and more organized.',
  },
  {
    id: 3,
    avatar: '/showcase/enterprise/avatar-1.png',
    name: 'Lisa Wu',
    title: 'Love the simplicity of Dashboard!',
    role: 'Front-end Developer at Google',
    say: 'Very nice dashboard. my team also feel comfortable when using it and our work becomes easier and more organized.',
  },
];

export default function Testimonials() {
  const [page, setPage] = React.useState(0);

  return (
    <div className={css({ position: 'relative', overflow: 'visible' })}>
      <div
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          mb: '48',
          xlDown: { flexDirection: 'column' },
        })}
      >
        <h2 className={css({ color: '#fff', xlDown: { mb: '3', textAlign: 'center' } })}>
          What Our Client Says about us ?
        </h2>
        <div className={css({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' })}>
          <ShaojiangImage
            alt='pre'
            src='/showcase/enterprise/pre.svg'
            className={cx(
              css({ cursor: 'pointer', borderRadius: 'full' }),
              page === 0 && css({ bg: '#307EF3' }),
            )}
            onClick={() => setPage(0)}
          />
          <span className={css({ px: '6', '2xlDown': { px: '4' } })}></span>
          <ShaojiangImage
            alt='next'
            src='/showcase/enterprise/pre.svg'
            className={cx(
              css({ cursor: 'pointer', transform: 'rotate(180deg)', borderRadius: 'full' }),
              page === 1 && css({ bg: '#307EF3' }),
            )}
            onClick={() => setPage(1)}
          />
        </div>
      </div>
      <div
        className={cx(
          css({
            transitionTimingFunction: 'ease-in-out',
            position: 'absolute',
            top: '40',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: '6',
            w: '1440px',
            transition: 'all 0.15s',
          }),
          page === 1 && css({ right: '0!' }),
        )}
      >
        {testimonialRecords.map((t) => (
          <div
            key={t.id}
            className={css({
              boxShadow: '0px 97.347px 112.922px 0px rgba(12, 36, 122, 0.07)',
              bg: '#fff',
              _dark: { bg: 'rgb(49, 45, 75)' },
              pt: '6',
              borderRadius: '2xl',
              maxW: '400px',
            })}
          >
            <div className={css({ display: 'flex', justifyContent: 'space-between', px: '8' })}>
              <h3 className={css({ maxW: '240px', color: '#23293D', _dark: { color: '#fff' } })}>
                {t.title}
              </h3>
              <ShaojiangImage alt='say' src='/showcase/enterprise/say.svg' />
            </div>
            <p
              className={css({
                p: '8',
                color: '#23293D',
                _dark: { color: '#fff' },
                opacity: 0.5,
                lineHeight: '2',
              })}
            >
              {t.say}
            </p>
            <div
              className={css({
                borderBottomRadius: '2xl',
                px: '8',
                py: '6',
                display: 'flex',
                alignItems: 'center',
                bgImage: 'linear-gradient(to right, #EFF5FB 6.16%, #fff 52%, #EFF5FB 92.61%)',
                _dark: { bgColor: 'rgb(36, 33, 57)', bgImage: 'none' },
              })}
            >
              <ShaojiangImage alt='avatar' src={t.avatar} width={90} height={90} />
              <div className={css({ color: '#23293D', _dark: { color: '#fff' }, ml: '8' })}>
                <p className={css({ textStyle: 'xl' })}>{t.name}</p>
                <p className={css({ opacity: 0.5 })}>{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
